<template>
    <div>
        <ModalCommon :id="`ModalListPreview`" :config="config" @close="handleClose()" :isView="true">
            <div class="form-group row">
                <label class="col-sm-1" style="min-width: 150px">{{ $t('pageCampaign.defaultCampaign') }}</label>
                <div v-if="!!formData?.campaign_not_change?.name" class="col-sm-9">
                    {{ formData?.campaign_not_change?.name ?? '' }}
                    <button v-if="checkPermission('campaign.view')" type="button" @click="onHandleGoToDetail" class="btn btn-sm btn-info ml-3">
                        {{ $t('btn.detail') }}
                    </button>
                </div>
            </div>
            <template>
                <h5 class="p-3 rounded font-weight-bold" style="background-color: #e5e5d8">{{ $t('pageCampaign.linkListLP') }}</h5>
                <div class="table-responsive">
                    <table class="table table-bordered table-box">
                        <thead>
                            <th>{{ $t('landingPage.list.nameLandingPage') }}</th>
                            <th>{{ $t('landingPage.list.urlPublic') }}</th>
                            <th>{{ $t('landingPage.list.status') }}</th>
                            <th>{{ $t('managerForm.list.publishTime') }}</th>
                            <th></th>
                        </thead>
                        <tbody>
                            <template v-if="listLandingPage?.length > 0">
                                <tr v-for="(itemLp, idx) in listLandingPage" :key="idx">
                                    <td style="width: 200px">
                                        <div class="row-data-large" v-b-tooltip.hover :title="itemLp.name">
                                            {{ itemLp.name ?? '' }}
                                        </div>
                                    </td>
                                    <td style="width: 600px">
                                        <div class="row-data-large" style="max-width: 600px" v-b-tooltip.hover :title="getLpUrl(itemLp)">
                                            <span v-if="!itemLp.is_first_update || itemLp.status === 1" class="element__span">{{
                                                getLpUrl(itemLp)
                                            }}</span>
                                            <a v-else :href="getLpUrl(itemLp)" target="_blank" class="d-block element__span">{{
                                                getLpUrl(itemLp)
                                            }}</a>
                                        </div>
                                    </td>
                                    <td style="min-width: 100px" class="text-left">{{ renderNameStt(itemLp.status, 'lp') }}</td>
                                    <td style="min-width: 200px" class="text-left">
                                        <div v-if="!!itemLp?.lp_start_date && !!itemLp?.lp_end_date">
                                            <span class="d-block">{{ formatDateCommon(itemLp?.lp_start_date, 'dateTimeJP') ?? '' }}</span>
                                            <span class="d-block">{{ formatDateCommon(itemLp?.lp_end_date, 'dateTimeJP') ?? '' }}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <button
                                            v-if="checkPermission('landing_page.view')"
                                            type="button"
                                            @click="onHandleDetailLink(itemLp, 'lp')"
                                            class="btn btn-sm btn-info"
                                        >
                                            {{ $t('btn.detail') }}
                                        </button>
                                    </td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="4" class="text-center">
                                        {{ $t('notificationCommon.viewLandingPageEmpty') }}
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </template>
            <template>
                <h5 class="p-3 rounded font-weight-bold" style="background-color: #e5e5d8">{{ $t('pageCampaign.linkListForm') }}</h5>
                <div class="table-responsive">
                    <table class="table table-bordered table-box">
                        <thead>
                            <th>{{ $t('managerForm.list.nameForm') }}</th>
                            <th>{{ $t('managerForm.list.urlPublic') }}</th>
                            <th>{{ $t('managerForm.list.status') }}</th>
                            <th>{{ $t('managerForm.list.publishTime') }}</th>
                            <th></th>
                        </thead>
                        <tbody>
                            <template v-if="listForm?.length > 0">
                                <tr v-for="(itemLp, idx) in listForm" :key="idx">
                                    <td style="width: 200px">
                                        <div class="row-data-large" v-b-tooltip.hover :title="itemLp.name">
                                            {{ itemLp.name ?? '' }}
                                        </div>
                                    </td>
                                    <td style="width: 600px">
                                        <div class="row-data-large" style="max-width: 600px" v-b-tooltip.hover :title="getFormUrl(itemLp)">
                                            <a
                                                v-if="itemLp.status === STATUS_FORM_LIST.PUBLISHING && !itemLp.is_first_create"
                                                :href="getFormUrl(itemLp)"
                                                target="_blank"
                                                class="d-block element__span"
                                                >{{ getFormUrl(itemLp) }}</a
                                            >
                                            <span v-else class="element__span">{{ getFormUrl(itemLp) }}</span>
                                        </div>
                                    </td>
                                    <td style="min-width: 100px" class="text-left">{{ renderNameStt(itemLp.status, 'form') }}</td>
                                    <td style="min-width: 200px" class="text-left">
                                        <template
                                            v-if="itemLp.is_publish_start_date_now === OPTION_PUBLIC_START_FORM[1].id && !itemLp.publish_start_date"
                                        >
                                            <span>{{ $t('managerForm.list.nothingDate') }}</span>
                                        </template>
                                        <span>
                                            {{ formatDateCommon(itemLp.publish_start_date, 'dateTimeJP') }}
                                            <br clear="none" />
                                            <template v-if="itemLp.publish_has_no_end_date">
                                                {{ OPTION_PUBLIC_END_FORM[0].name }}
                                            </template>
                                            <template v-else>
                                                {{ formatDateCommon(itemLp.publish_end_date, 'dateTimeJP') }}
                                            </template>
                                        </span>
                                    </td>
                                    <td>
                                        <button
                                            v-if="checkPermission('form.view')"
                                            type="button"
                                            @click="onHandleDetailLink(itemLp, 'form')"
                                            class="btn btn-sm btn-info"
                                        >
                                            {{ $t('btn.detail') }}
                                        </button>
                                    </td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="4" class="text-center">
                                        {{ $t('notificationCommon.viewFormEmpty') }}
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </template>
        </ModalCommon>
    </div>
</template>

<script>
import ModalCommon from '@/components/Modal/main.vue';
import { checkPermission } from '@/utils/handlers';

import { STATUS_SETTING_BASIC } from '@/views/pages/phase2/landing-page/constants';
import { STATUS_FORM, STATUS_FORM_LIST, OPTION_PUBLIC_START_FORM, OPTION_PUBLIC_END_FORM } from '@/views/pages/phase2/manager-form/constants';
import { foundTypePageForm } from '@/views/pages/phase2/manager-form/handlers';
import { formatDateCommon } from '@/utils/format';
export default {
    name: 'ModalListPreview',
    components: {
        ModalCommon
    },
    props: {
        config: {
            type: Object,
            default: () => {}
        },
        formData: {
            type: Object,
            default: () => {}
        },
        list: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            domain: process.env.VUE_APP_DOMAIN_LP,
            STATUS_FORM_LIST,
            OPTION_PUBLIC_START_FORM,
            OPTION_PUBLIC_END_FORM
        };
    },
    computed: {
        listLandingPage() {
            return this.formData.landing_pages?.map((item) => item).sort((a, b) => b.id - a.id);
        },

        listForm() {
            return this.formData.forms?.map((item) => item).sort((a, b) => b.id - a.id);
        }
    },
    methods: {
        checkPermission,
        foundTypePageForm,
        formatDateCommon,
        handleClose() {
            let config = this.config;
            config.model = false;
            this.$emit('update:config', config);
        },

        renderNameStt(status, type = 'lp') {
            if (!status) return '';
            if (type === 'lp') return STATUS_SETTING_BASIC.find((itemStt) => itemStt.id === status)?.value ?? '';
            if (type === 'form') return STATUS_FORM.find((itemStt) => itemStt.id === status)?.value ?? '';
        },

        onHandleGoToDetail() {
            window.location.href = `${window.location.origin}/campaign/form/view?id=${this.formData?.campaign?.id ?? this.formData.id}`;
        },

        onHandleDetailLink(itemLp, type = 'lp') {
            if (type === 'lp') window.location.href = `${window.location.origin}/landing-page/view?id=${itemLp.id}`;
            if (type === 'form') window.location.href = `${window.location.origin}/manager-form/view?id=${itemLp.id}`;
        },

        getLpUrl(item) {
            const domain = item?.domain || process.env.VUE_APP_DOMAIN_LP;
            return `https://${domain}/landing-page/${item.url_public}`;
        },

        getFormUrl(item) {
            const domain = item?.domain || process.env.VUE_APP_DOMAIN_FORM;
            return `https://${domain}/form/${item.url_public}`;
        }
    }
};
</script>

<style lang="scss" scoped>
.element__span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre;
    min-width: 100px;
    width: fit-content;
    flex: 3;
}
</style>
